<template>
    <div>
        <div class="form-horizontal" encregion="multipart/form-data" @submit.prevent="store" @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                   <th>{{ uLang('app.name') }}</th>
                   <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="trajectoryType in trajectoryTypes">
                    <td>
                        <input type="text" v-if="trajectoryType.editable" class="form-control" :name="trajectoryType.value" v-model="form['value'][trajectoryType.id]">
                        <span v-if="!trajectoryType.editable">{{ trajectoryType.value }}</span>
                    </td>
                    <td>
                        <a href="#" @click.prevent="removeTrajectoryType(trajectoryType)" class="btn btn-danger" v-if="trajectoryType.deleteable" :title="uLang('app.delete_trajectoryType')">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newTrajectoryType" :placeholder="uLang('app.new_trajectory_type')" :title="uLang('app.add_new_trajectory_type')">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addTrajectoryType" :disabled="form.busy">{{ uLang('app.create_entity', { entity: lang('app.trajectory_type')}) }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()" class="btn btn-brand" />
            </div>
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { ErrorAlert, SuccessAlert, DestroyAlert } from '~/Swals'

    export default {
        props: {
            settingId: {
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    value: {},
                }),
                newTrajectoryType: '',
                trajectoryTypes: []
            }
        },
        mounted: function () {
            this.retrieveValues();
        },
        methods: {
            async store() {
                this.form['patch']('/api/admin/settings/' + this.settingId)
                    .then(response => {
                        this.setValues(response);
                        new SuccessAlert({ text: this.uLang('app.entity_updated', { entity: lang('app.trajectory_types')})}).show();
                    })
                    .catch(error => {
                        new ErrorAlert({
                            title: uLang('app.oops_something_went_wrong'),
                            text: uLang('app.all_inputs_need_to_be_filled'),
                        }).show();
                    });
            },

            setValues(data) {
                this.form.value = {};

                this.trajectoryTypes = data;

                data.forEach(function (trajectoryType){
                    if(trajectoryType.editable){
                        this.value[trajectoryType.id] = trajectoryType.value;
                    }

                }, this.form);

            },

            async retrieveValues() {
                // TODO: Check if this basic setting logic happens in other components, and maybe move to mixin
                const { data } = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

                this.setValues(data);
            },

            addTrajectoryType() {
                if (this.newTrajectoryType === '')
                    return;


                this.trajectoryTypes.push(
                    {
                        id: this.newTrajectoryType,
                        value: this.newTrajectoryType,
                        deleteable: 1,
                        editable: 1
                    }
                );
                this.form.value[this.newTrajectoryType] = this.newTrajectoryType;
                this.newTrajectoryType = '';
            },

            removeTrajectoryType(trajectoryType) {
                new DestroyAlert({ entity: this.lang('app.trajectory_type') }).show().then(async () => {

                    delete this.form.value[trajectoryType.id];

                    //remove the trajectory type from the table
                    this.trajectoryTypes = this.trajectoryTypes.filter(function (current_trajectory_type) {
                        return current_trajectory_type.value != trajectoryType.value;
                    });
                })
            }
        }
    }
</script>

<style lang="css" scoped>

</style>
